import { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { FilledTooltipTitle } from "../../../../Constants/Constants";
import { FilledTooltipSubTitle, FlippedTooltipData } from "../../../../Data/UiKits/Tooltip";

const FilledTooltip = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleTooltip = (index: number) => setOpenIndex(openIndex === index ? null : index);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FilledTooltipTitle} span={FilledTooltipSubTitle} />
        <CardBody className="fill-tooltip">
          <div className="common-flex">
            {FlippedTooltipData &&
              FlippedTooltipData.map((item, index) => (
                <Fragment key={index}>
                  <Btn outline={true} color={item.class} id={`filled_${index}`} onClick={() => toggleTooltip(index)}>
                    {item.text}
                  </Btn>
                  <ToolTip isOpen={openIndex === index} target={`filled_${index}`} toggle={() => toggleTooltip(index)}>
                    {item.text}
                  </ToolTip>
                </Fragment>
              ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default FilledTooltip;
